import http from '@/utils/http' //引入axios

export const getRole = data => http.get('/user-center/api/role', {
  params: data
}) //获取角色
export const addRole = data => http.post('/user-center/api/role', data) //添加角色
export const updataRole = data => http.put('/user-center/api/role', data) //編輯角色
export const deleteRole = data => http.delete('/user-center/api/role', {
  params: data
}) //根据id刪除角色
export const updataRoleMenu = data => http.put('/user-center/api/role/menu', data) //編輯角色菜单
export const searchRole = data => http.get('/user-center/api/role', {
  params: data
}) //查询角色

export const exportRole = data => http.get('/user-center/api/role/excel', {
  params: data,
  responseType: 'blob'
})

export default {
  getRole,
  addRole,
  updataRole,
  deleteRole,
  updataRoleMenu,
  searchRole,
  exportRole
}